import React, { useState } from "react";
import "../styles/LoginForm.css";
import { useAuth } from "../context/auth_context_provider";
import { authApi } from "../services/api";

export const LoginForm: React.FC = () => {
  const { login } = useAuth();
  const [formData, setFormData] = useState({
    login: "",
    password: "",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!formData.login.trim() || !formData.password.trim()) {
      setError("Please fill in all fields");
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const response = await authApi.login({
        login: formData.login,
        password: formData.password,
      });

      if (response.token && response.expiresAt) {
        const userData = {
          id: 1,
          login: formData.login,
        };
        login(response.token, userData, response.expiresAt, {
          login: formData.login,
          password: formData.password,
        });
      } else {
        setError(response.message || "Invalid response from server");
      }
    } catch (err: any) {
      let errorMessage = "Login failed";

      if (err.response?.data) {
        const data = err.response.data;

        if (typeof data === 'string') {
          errorMessage = data;
        } else if (typeof data.message === 'string') {
          errorMessage = data.message;
        } else if (typeof data.message === 'object' && data.message.message) {
          errorMessage = data.message.message;
        } else if (data.error) {
          errorMessage = data.error;
        }
      } else if (err.message) {
        errorMessage = err.message;
      }

      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <form onSubmit={handleSubmit} className="login-form">
        <h2>Login</h2>
        <div className="form-group">
          <label htmlFor="login">Login:</label>
          <input
            id="login"
            name="login"
            type="text"
            value={formData.login}
            onChange={handleInputChange}
            placeholder="Enter your login"
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="password">Password:</label>
          <input
            id="password"
            name="password"
            type="password"
            value={formData.password}
            onChange={handleInputChange}
            placeholder="Enter your password"
            required
          />
        </div>
        {error && <div className="error-message">{error}</div>}
        <button type="submit" disabled={loading} className="submit-button">
          {loading ? "Logging in..." : "Login"}
        </button>
      </form>
    </div>
  );
};